module.exports = __webpack_public_path__ + "img/Sports-activities.392c576b.jpg";